// jshint esversion: 8
import ApiFactory from '@/api/ApiFactory';
const Dates = ApiFactory.get('dates');

const fetchAll = async ({ commit }, qs) => {
  const { data } = await Dates.getAll(qs);
  commit('SET_DATA', data);
};

export default {
  fetchAll
};
